/**
 * Backdrop for modals.
 *
 * TODO(kevbin):
 * - refactor so that there's only a single backdrop shared between all modals
 *   (should make hostInBody prop default in modal.jsx first)
 */

import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

type Props = {
    // Whether to fade in or out the backdrop, null signifies no animation
    animate: "in" | "out" | null;
    // Used when testing inside fixtures
    inline?: boolean;
    // Callback for click events
    onClick: () => unknown;
    // true if the modal will be visible at the end of the current
    // animation.
    // TODO(kevinb) use react-motion to simplify this
    willBeVisible: boolean;
};

const modalBackdropOpacity = 0.72;

class Backdrop extends React.Component<Props> {
    render(): React.ReactNode {
        const {willBeVisible, inline, onClick, animate} = this.props;

        const backdropStyles =
            animate !== null
                ? [
                      styles.backdrop,
                      animate === "in" && styles.animateInBackdrop,
                      animate === "out" && styles.animateOutBackdrop,
                      !willBeVisible && styles.backdropTransparent,
                      willBeVisible && styles.backdropSemiTransparent,
                  ]
                : [styles.backdrop, styles.backdropSemiTransparent];

        return (
            <div
                data-testid="modal-backdrop"
                aria-hidden={true}
                onClick={onClick}
                className={css(
                    ...backdropStyles,
                    inline && styles.inlineBackdrop,
                )}
            />
        );
    }
}

const TRANSITION_ANIMATION_DURATION = 300;

const styles = StyleSheet.create({
    backdrop: {
        backgroundColor: color.offBlack,
        bottom: 0,
        left: 0,
        position: "fixed",
        right: 0,
        top: 0,
    },
    inlineBackdrop: {
        position: "absolute",
    },
    backdropTransparent: {
        opacity: 0,
    },
    backdropSemiTransparent: {
        opacity: modalBackdropOpacity,
    },
    animateInBackdrop: {
        transition: `opacity ${TRANSITION_ANIMATION_DURATION}ms
            cubic-bezier(0.4, 0.0, 0.6, 1.0)`,
    },
    animateOutBackdrop: {
        transition: `opacity ${TRANSITION_ANIMATION_DURATION}ms
            cubic-bezier(0.4, 0.0, 0.6, 1.0)`,
    },
});

export default Backdrop;
